<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <RadioMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list/tobe`},
        { name: "订单列表" },
      ],
      menuIndex: `/contract/orderlist/own?id=${this.$route.query.id}`,
      menu: [
        {
          name: "自有车辆",
          path: `/contract/orderlist/own?id=${this.$route.query.id}`,
        },
        {
          name: "雇佣车辆",
          path: `/contract/orderlist/hire?id=${this.$route.query.id}`,
        },
        {
          name: "全部订单",
          path: `/contract/orderlist/all?id=${this.$route.query.id}`,
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menu.map(v => {
      const path = v.path.split('?')[0]
      // console.log(path)
      if (this.$route.path.includes(path)) {
        this.menuIndex = path + `?id=${this.$route.query.id}`
        // this.breadcrumb[1].path = v.path
        // this.breadcrumb.push({
        //   name: v.name
        // })
      }
    })
  },
};
</script>
